"use client"
import { createContext, useContext, useState, ReactNode } from 'react'

interface VideoModalContextType {
  openModal: (youtubeId: string, title: string) => void
  closeModal: () => void
  isOpen: boolean
  youtubeId: string | null
  title: string | null
}

const VideoModalContext = createContext<VideoModalContextType | undefined>(undefined)

export function VideoModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)
  const [youtubeId, setYoutubeId] = useState<string | null>(null)
  const [title, setTitle] = useState<string | null>(null)

  const openModal = (id: string, videoTitle: string) => {
    setYoutubeId(id)
    setTitle(videoTitle)
    setIsOpen(true)
  }

  const closeModal = () => {
    setIsOpen(false)
    setYoutubeId(null)
    setTitle(null)
  }

  return (
    <VideoModalContext.Provider value={{ openModal, closeModal, isOpen, youtubeId, title }}>
      {children}
    </VideoModalContext.Provider>
  )
}

export function useVideoModal() {
  const context = useContext(VideoModalContext)
  if (context === undefined) {
    throw new Error('useVideoModal must be used within a VideoModalProvider')
  }
  return context
}
